import { event } from "jquery";
import React from "react";
import { useState } from "react";

function ConfirmationCheckbox(props) {
  let [checked, setChecked] = useState(false);
  let { onHandleChecked } = props;
  let onChange = () => {
    setChecked(!checked);
    onHandleChecked(checked);
  };
  return (
    <input
      type="checkbox"
      className="form-check-input ml-0"
      name="checkbox"
      value={checked}
      selected={checked}
      onClick={onChange}
      checked={checked}
    />
  );
}

export default ConfirmationCheckbox;
